import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AuthCheck from './components/AuthCheck';

ReactDOM.render(
  <React.StrictMode>
    <AuthCheck><App /></AuthCheck>
  </React.StrictMode>,
  document.getElementById('root')
);